export default __webpack_public_path__ + "static/media/greenTick.2e87a234.svg";